import { createPortalConfig, LOCALES, filterLocalesByRole } from '@lucid/portal-core';
import { LuppApi } from '../api/services/lupp/lupp.service';
import { LUPP_API_BASE_PATH } from '../api/services/lupp/constants.lupp';
import type { UserIdentity } from '@lucid/portal-core';

/*
|--------------------------------------------------------------------------
| PAGES
| Register every page in this MFE here.
| enabled: false  →  permanently hidden regardless of VITE_ENABLED_PAGES
| Omit enabled   →  controlled by VITE_ENABLED_PAGES env var
|--------------------------------------------------------------------------
*/
const PAGES = [
  { id: 'dashboard', navId: 'dashboard' },
  { id: 'inbox', navId: 'inbox' },
  { id: 'notifications', navId: 'notifications' },
  { id: 'trackOrders', navId: 'track-orders' },
  { id: 'admin', navId: 'admin-panel' },
  { id: 'prospectDesk', navId: 'prospect-desk' },
  { id: 'orderHub', navId: 'order-hub' },
  { id: 'partsCenter', navId: 'parts-center' },
  { id: 'serviceCenter', navId: 'service-center' },
  { id: 'claimsCenter', navId: 'claims-center' },
  { id: 'vehicleHub', navId: 'vehicle-hub' },
  { id: 'customerCare', navId: 'customer-care' },
  { id: 'registrationDesk', navId: 'registration-desk' },
  { id: 'accountsDesk', navId: 'accounts-desk' },
];

export const portalConfig = createPortalConfig({
  defaultLocale: 'de-de',
  defaultLanguage: 'en',
  rolesNamespace: `https://${import.meta.env.VITE_AUTH0_DOMAIN}/roles`,
  fetchIdentity: () => LuppApi.get<UserIdentity>(`${LUPP_API_BASE_PATH}/partners/me`),
  crossAppPrefixes: [],
  locales: LOCALES,
  pages: PAGES,
  filterLocalesByRole,
});
